/**
 * Video Route
 * Waiting room and video session
 */
import { createFileRoute } from "@tanstack/react-router";
import { VideoPage } from "../pages/VideoPage";

export const Route = createFileRoute("/video/$appointmentId")({
  component: VideoPage,
});
